var map = {
	"./en.json": "f7hK",
	"./zh.json": "gJDF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Cvun";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/langs ^\.\/.*\.json$
// module id = Cvun
// module chunks = 1